<template>
    <section>
        <button
            class="inline-flex items-center px-5 py-2 border border-green-700 rounded-md shadow text-base font-semibold text-green-50 bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
            @click="triggerFileUpload('bestand')"
        >
            <svg
                class="fill-current w-6 h-6 mr-2"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"
                ></path>
            </svg>

            {{ t("attendees.import.button-excel", "Upload Excel voor import") }}
        </button>

        <input
            type="file"
            id="bestand"
            ref="bestand"
            foobar-accept=".xlsx, .xls"
            v-on:change="handleFileUpload('bestand')"
            style="display: none"
        />

        <info-box :message="info"></info-box>
        <empty-list :message="warning" class="mt-4"></empty-list>
    </section>
</template>

<script>
import { InformationCircleIcon } from "@heroicons/vue/solid";
import Swal from "sweetalert2";
import EmptyList from "../../../components/EmptyList.vue";
import InfoBox from "../../../components/InfoBox.vue";

export default {
    components: {
        InformationCircleIcon,
        InfoBox,
        EmptyList,
    },
    mounted() {
        const info =
            '<b>Excel-import</b><br>Middels het onderstaande Excel-format kunt u alle Deelnemers toevoegen deze daarna uploaden.<br/><a href="/documents/import-template-alv.xlsx"><u>Download het Excel-format</u></a>';

        var importFile = "import-template-alv.xlsx";
        importFile = "import-template-alv";
        if (document.documentElement.lang == "de") {
            importFile = "import-vorlage-online-mgv.xlsx";
        }
        this.info =
            "<b>" +
            this.t("attendees.import.info.title", "Excel-import") +
            "</b><br>" +
            this.t(
                "attendees.import.info.text",
                "Middels het onderstaande Excel-format kunt u alle Deelnemers toevoegen deze daarna uploaden.",
            ) +
            '<br/><a href="/documents/' +
            importFile +
            '"><u>' +
            this.t(
                "attendees.import.info.download-text",
                "Download het Excel-format",
            ) +
            "</u></a>";

        this.warning =
            "<b>" +
            this.t(
                "attendees.import.warning.title",
                "Let op het volgende bij het importeren:",
            ) +
            "</b><br>" +
            this.t(
                "attendees.import.warning.text",
                "• E-mailadressen moeten uniek zijn en mogen maar één keer voorkomen.<br>• Een mobiel telefoonnummer is noodzakelijk om in te kunnen loggen met SMS-verificatie.",
            );
    },
    created() {},
    data() {
        return {
            info: null,
            warning: null,
        };
    },
    methods: {
        triggerFileUpload(field) {
            document.getElementById(field).click();
        },
        handleFileUpload(field) {
            this.file = this.$refs.bestand.files[0];
            var self = this;
            let formData = new FormData();
            formData.append("bestand", this.file);
            window.scroll({
                top: 0,
                left: 0,
                behavior: "smooth",
            });
            axios
                .post("/api/import-users", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then(function (response) {
                    if (response.data) {
                        Eventing.fire("notify", {
                            title: self.t("attendees.import.success", "Gelukt"),
                            message: self.t(
                                "attendees.import.success-text",
                                "Bestand wordt geïmporteerd",
                            ),
                            type: "alert",
                            position: "center",
                        });
                        self.$router.replace({ name: "attendees-index" });
                    }
                })
                .catch((error) => {
                    //console.error(error);
                    if (error.response) {
                        // if (error.response.status == 403) {
                        //     alert("Geen toegang hiervoor");
                        // }
                        // if (error.response.status == 404) {
                        //     alert("Niet (meer) beschikbaar");
                        // }
                        // if (error.response.status == 422) {
                        //     alert("Bestand niet van het formaat Excel");
                        // }
                        if (error.response.status == 409) {
                            Swal.fire(
                                self.t(
                                    "attendees.import.failed-title",
                                    "Import mislukt",
                                ),
                                self.t(
                                    "attendees.import.excel-incorrect",
                                    "Template niet correct gevuld en/of uw Excel-sheet is voorzien van een wachtwoord.",
                                ),
                                "error",
                            );
                        }
                        if (error.response.status == 500) {
                            Swal.fire(
                                self.t(
                                    "attendees.import.failed-title",
                                    "Import mislukt",
                                ),
                                self.t(
                                    "attendees.import.file-failure",
                                    "Er is wat mis met de aangeleverd Excel. Probeer het nog eens.",
                                ),
                                "error",
                            );
                            setTimeout(() => {
                                window.location.reload();
                            }, 1000);
                        }
                        // if (error.response.status == 500) {
                        //     // alert("Hier ging wat mis op de server.\nProbeer het nog eens.");
                        // }
                    }
                })
                .finally(function () {});
        },
    },
};
</script>
